export interface DocumentStatusOption {
  id: number;
  label: string;
}

// 3-status workflow: New (1), In Progress (2), Completed (4).
// Legacy statuses 3 (Ready for Review) and 5 (In Revision) are intentionally
// excluded from PM dropdowns but remain valid backend IDs for old documents.
export const DOCUMENT_STATUS: DocumentStatusOption[] = [
  { id: 1, label: "New" },
  { id: 2, label: "In Progress" },
  { id: 4, label: "Completed" },
];
